import { Link } from "react-router-dom";
import { X, Sparkles } from "lucide-react";

/**
 * Small friendly gate shown when an anonymous user tries to start a Try-On.
 * Two outbound actions: Entrar (login) and Cadastre-se (register), both
 * preserving the original target via the ?redirect= query string.
 *
 * Usage:
 *   const [promptOpen, setPromptOpen] = useState(false);
 *   ...
 *   <LoginPromptModal open={promptOpen} onClose={() => setPromptOpen(false)} redirectTo={target} />
 */
export default function LoginPromptModal({ open, onClose, redirectTo }) {
  if (!open) return null;
  const redirectQS = redirectTo ? `?redirect=${encodeURIComponent(redirectTo)}` : "";

  return (
    <div
      data-testid="login-prompt-modal"
      className="fixed inset-0 z-[200] bg-black/40 flex items-end md:items-center justify-center"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white border-2 border-[#B8A88A] w-full md:max-w-md md:rounded-none rounded-t-2xl md:rounded-t-none p-8"
      >
        <div className="flex items-center justify-between mb-6">
          <span className="inline-flex items-center gap-2 text-[#B8A88A]">
            <Sparkles size={16} strokeWidth={1.6} />
            <span className="overline">Experimentar</span>
          </span>
          <button
            onClick={onClose}
            data-testid="login-prompt-close"
            aria-label="Fechar"
            className="text-[#6B6B6B] hover:text-[#1A1A1A]"
          >
            <X size={18} />
          </button>
        </div>

        <h3 className="font-display text-2xl md:text-3xl leading-tight mb-3">
          Quase lá...
        </h3>
        <p className="text-[15px] text-[#4A4A4A] leading-relaxed mb-8">
          Para experimentar, basta fazer login ou um cadastro rapidinho.
        </p>

        <div className="space-y-3">
          <Link
            to={`/login${redirectQS}`}
            data-testid="login-prompt-login-btn"
            className="btn-primary w-full block text-center"
            onClick={onClose}
          >
            Entrar
          </Link>
          <Link
            to={`/cadastro${redirectQS}`}
            data-testid="login-prompt-register-btn"
            className="btn-secondary w-full block text-center"
            onClick={onClose}
          >
            Cadastre-se
          </Link>
        </div>
      </div>
    </div>
  );
}
